import $ from 'jquery';
import '../css/popover.css';
import { createPopover } from './utils/popover';

function initializePopovers() {
    document.querySelectorAll('[data-popover]').forEach((el) => {
        const content = el.getAttribute('data-popover');
        const placement = el.getAttribute('data-popover-placement') || 'bottom';
        const trigger = el.getAttribute('data-popover-trigger') || 'hover';
        const theme = el.getAttribute('data-popover-theme') || '';

        if (content && !el.hasAttribute('data-popover-initialized')) {
            createPopover(el, content, {
                placement,
                trigger,
                theme,
            });
            el.setAttribute('data-popover-initialized', 'true');
        }
    });

    document.querySelectorAll('[data-popover-content]').forEach((trigger) => {
        if (trigger.hasAttribute('data-popover-initialized')) return;

        const contentSelector = trigger.getAttribute('data-popover-content');
        const contentEl = document.querySelector(contentSelector);
        const placement = trigger.getAttribute('data-popover-placement') || 'top';
        const triggerType = trigger.getAttribute('data-popover-trigger') || 'hover';
        const theme = trigger.getAttribute('data-popover-theme') || '';

        if (contentEl) {
            let content;
            
            if (contentEl.tagName === 'TEMPLATE') {
                const fragment = contentEl.content.cloneNode(true);
                const wrapper = document.createElement('div');
                wrapper.appendChild(fragment);
                content = wrapper;
            } else {
                content = contentEl.cloneNode(true);
            }

            createPopover(trigger, content, {
                placement,
                trigger: triggerType,
                theme,
            });
            trigger.setAttribute('data-popover-initialized', 'true');
        }
    });
}

$(document).ready(function() {
    initializePopovers();

    const popoverObserver = new MutationObserver(() => {
        initializePopovers();
    });

    if (document.body) {
        popoverObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    window.initializePopovers = initializePopovers;
});

$('select').each(function() {
    $(this).wrap('<div class="select-wrapper"></div>')
})
$('input[type=checkbox]').each(function () {
    if (this.checked) {
        $(this).addClass('form__checkbox--checked')
    }
}).on('click', function() {
    if (this.checked) {
        $(this).addClass('form__checkbox--checked')
    } else {
        $(this).removeClass('form__checkbox--checked')
    }
})

$('.box--collapse').each(function() {
    let box = $(this)
    let heading = box.find('.box_heading')
    heading.on('click', () => {
        if (box.is('.box--open')) {
            box.removeClass('box--open')
        } else {
            box.addClass('box--open')
        }
    })
})

$('a.form-link').on('click', function (event) {
    let link = $(this)
    let href = link.data('href')
    let confirm = link.data('confirm')
    let token = link.data('token')
    let method = link.data('method')

    if (!href) {
        alert('missing post href')
        event.preventDefault()
        return false
    }

    if (confirm && !window.confirm(confirm)) {
        return
    }

    let form = $('<form action="'+href+'" method="post"><input type="submit" /></form>')
    if (token) {
        form.append('<input type="hidden" name="_token" value="'+token+'"></input>')
    }
    if (method) {
        form.append('<input type="hidden" name="_method" value="'+method+'"></input>')
    }

    form.hide().insertAfter(link).trigger('submit')
})


$('.tab-container .tab a').on('click', function() {
    $('.tab-container .tab').removeClass('tab-active')
    $(this).parent('.tab').addClass('tab-active')
    $('.tab-content').hide()
    $('#'+this.dataset.target).show()
})
$('.tab-container .tab a:first').trigger('click')



var $nav = $('body[data-active-nav-elem]');
if ($nav.length) {
  var activeName = $nav.attr('data-active-nav-elem');
  var $activeLink = $nav.find('.mscp-main-nav-item[data-nav-elem="' + activeName + '"]');
  if ($activeLink.length) $activeLink.addClass('mscp-main-nav-item--active');
}

$('.mscp-main-nav-item--expand').each(function() {
    const $dropdown = $(this);
    const $submenu = $dropdown.find('.mscp-main-nav-item-submenu');
    
    $dropdown.on('click touchstart', function(e) {
        e.stopPropagation();
        $('.mscp-main-nav-item--expand').not($dropdown).removeClass('mscp-main-nav-item--open');
        $dropdown.toggleClass('mscp-main-nav-item--open');
    });
    
    $submenu.on('click touchstart', function(e) {
        e.stopPropagation();
    });
});

$(document).on('click touchstart', function(e) {
    if (!$(e.target).closest('.mscp-main-nav-item--expand').length) {
        $('.mscp-main-nav-item--expand').removeClass('mscp-main-nav-item--open');
    }
});


$('.toggle_password').each(function() {
    const password = $(this)
    const $iconWrap = password.find('.password_icon');
    const $showIcon = password.find('.pwshow');
    const $hideIcon = password.find('.pwhide');

    let isVisible = false;

    $iconWrap.on('click', function() {
        if(isVisible == false) {
            $showIcon.removeClass('hidden');
            $hideIcon.addClass('hidden');
        } else {
            $showIcon.addClass('hidden');
            $hideIcon.removeClass('hidden');
        }
        isVisible = !isVisible;
    });
});

function updateRequestStateUI(radio) {
    var requestId = radio.dataset.requestid;
    var value = radio.value;
    var isWaiting = radio.checked && value == 'waiting';

    $(`.request-comment-${requestId}-form-wrapper`).toggle(isWaiting);
    $(`.request-comment-${requestId}-disclaimer`).toggle(!isWaiting);

    var commentBox = `.request-comment-${requestId}-box`;
    if (isWaiting && !$(commentBox).hasClass('box--open')) {
        $(commentBox).addClass('box--open')
    }
}

// Attach change handler
$('.request-state-form .js-state-radio').on('change', function(e) {
    updateRequestStateUI(e.target);
});

// Run on page load for all checked radios
$('.request-state-form .js-state-radio:checked').each(function() {
    updateRequestStateUI(this);
});

// UserType: update the visibility of the roles field based on the selected company
function updateRolesFieldVisibility() {
    const $companySelect = $('#user_company');
    const $rolesField = $('#user_roles');
    const $rolesContainer = $rolesField.closest('.form__row');
    
    if ($companySelect.length && $rolesContainer.length) {
        // Add link to roles label if not already present
        const $label = $rolesContainer.find('label').first();
        if ($label.length && !$label.find('a.fw-button-secondary').length) {
            $label.append('<span style="float: right;"><a href="/admin/role-permission-matrix" target="_blank" class="fw-button-secondary">Rollenmatrix</a></span>');
        }
        
        const selectedCompanyText = $companySelect.find('option:selected').text();
        const shouldShowRoles = !$companySelect.val() || selectedCompanyText === 'EWE TEL GmbH';
        
        if (shouldShowRoles) {
            $rolesContainer.show();
        } else {
            $rolesContainer.hide();
        }
    }
}

$(document).on('change', '#user_company', function() {
    updateRolesFieldVisibility();
});

$(document).ready(function() {
    updateRolesFieldVisibility();
});

const page = document.querySelector('body').dataset.page

if (page == 'attributesForm') {
    import('./pages/attributesForm')
} else if (page == 'search') {
    import('./pages/search')
} else if (page == 'otp_setup') {
    import('./pages/otpSetup')
} else if (page == 'location') {
    import('./pages/location')
} else if (page == 'permissions') {
    import('./pages/permissions')
} else if (page == 'preview') {
    import('./pages/preview')
} else if (page == 'homepage') {
    import('./pages/homepage')
} else if (page == 'locationForm') {
    import('./pages/locationForm')
} else if (page == 'customerSearch') {
    import('./pages/customerSearch')
}

$('.mscp-error-token code').on('click', function() {
    const text = $(this).text();
    const $this = $(this);
    
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
            const originalText = $this.text();
            const originalWidth = $this.outerWidth();
            
            $this.css('width', originalWidth + 'px')
                 .addClass('mscp-error-token--copied')
                 .text('Kopiert');
            
            setTimeout(() => {
                $this.removeClass('mscp-error-token--copied')
                     .css('width', '')
                     .text(originalText);
            }, 1000);
        });
    }
});